// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingScreen_container__2L95F","subContainer":"LoadingScreen_subContainer__ZSdT9","loading":"LoadingScreen_loading__3WJ2d","ellipsis":"LoadingScreen_ellipsis__2VjqK"};